<mat-menu #userMenu="matMenu" class="customized-menu">
  <button
    *ngIf="showTenantMenu"
    [matMenuTriggerFor]="tenantMenu?.menuRef"
    xposition="before"
    (click)="updateTenantMenu()"
    mat-menu-item
  >

    <span>Mandanten wechseln</span>
  </button>

  @if (this.themeService.themeClass !== 'light-theme') {
    <button
      (click)="applyTheme.emit('light-theme')"
      mat-menu-item
    >
      <span> Helles Design setzen </span>
    </button>
  }

  @if (this.themeService.themeClass !== 'dark-theme') {
    <button
      (click)="applyTheme.emit('dark-theme')"
      mat-menu-item
    >
      <span> Dunkles Design setzen </span>
    </button>
  }


  @if (this.themeService.themeClass !== 'custom-theme') {
    <button
      (click)="applyTheme.emit('custom-theme')"
      mat-menu-item
    >
      <span> Custom-Design setzen </span>
    </button>
  }


  @if (this.themeService.themeClass !== 'system-theme') {
    <button
      (click)="applyTheme.emit('system-theme')"
      mat-menu-item
    >
      <span> Betriebssystem-Design übernehmen </span>
    </button>
  }
  <button
    (click)="changeUser()"
    mat-menu-item
  >

    <span>Benutzerdaten ändern</span>
  </button>

  <button
    (click)="changeMail()"
    mat-menu-item
  >
    <span>E-Mail-Adresse ändern</span>
  </button>

  <button
    *ngIf="menuOptions.length !== 0"
    [matMenuTriggerFor]="optionsMenu?.menuRef"
    xposition="before"
    mat-menu-item
  >
    <span>Optionen</span>
  </button>

  <button
    (click)="changeOwnPassword()"
    mat-menu-item
  >
    <span>Passwort ändern</span>
  </button>

  @if (helpUrl || helpView) {
    <button
      (click)="openHelp()"
      mat-menu-item
    >
      <span>Hilfe</span>
    </button>
  }

  @if (supportUrl) {
    <button
      (click)="openSupport()"
      mat-menu-item
    >
      <span>Support</span>
    </button>
  }

  <button
    (click)="logout.emit()"
    mat-menu-item
  >
    <span>Ausloggen</span>
  </button>
</mat-menu>

<kpi4me-tenant-menu [moduleFilters]="moduleFilters"></kpi4me-tenant-menu>

<kpi4me-options-menu
  [options]="menuOptions"
  (optionTriggered)="optionTriggered.emit($event)"
></kpi4me-options-menu>
